<template>
  <div class="list-page">
    <!-- 蓝色头部：图标 + 主标题 + 副标题（统一放入 banner） -->
    <div class="detail-banner">
      <div class="container">
        <div class="os-banner">
          <div class="os-banner-text">
            <h1>{{ bannerTitle }}</h1>
            <p v-if="subtitle" class="os-banner-sub">{{ subtitle }}</p>
          </div>
        </div>
      </div>
    </div>

    <section class="section">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>

        <div v-if="loading" class="empty-block">加载中…</div>

        <div v-else-if="service" class="os-info">
          <!-- 富文本详细内容 -->
          <div class="os-section" v-if="service.detailContent">
            <div class="rich-content" v-html="service.detailContent"></div>
          </div>

          <!-- 外链地址 -->
          <div class="os-link" v-if="service.linkUrl">
            <a
              class="os-link-btn"
              :href="service.linkUrl"
              target="_blank"
              rel="noopener"
              >访问服务链接 ›</a
            >
          </div>

          <div class="os-contact">
            <button class="os-contact-btn" @click="consult">立即咨询</button>
          </div>
        </div>

        <div v-else class="empty-block">内容加载失败，请重试</div>
      </div>
    </section>
  </div>
</template>

<script>
import { fetchOverseasServiceDetail } from "../api/home";
import { WECHAT_WORK_CONSULT_URL } from "../config/site";

export default {
  name: "OverseaServiceInfo",
  props: ["id"],
  data() {
    return {
      service: null,
      loading: true,
    };
  },
  computed: {
    bannerTitle() {
      return this.service && this.service.title
        ? this.service.title
        : "服务详情";
    },
    subtitle() {
      return this.service && this.service.summary ? this.service.summary : "";
    },
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        this.service = await fetchOverseasServiceDetail(this.id);
      } catch (e) {
        this.service = null;
        this.$toast.show({
          message: (e && e.message) || "加载失败",
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },
    consult() {
      window.open(WECHAT_WORK_CONSULT_URL, "_blank", "noopener");
    },
    onImgError(e) {
      e.target.style.display = "none";
    },
  },
};
</script>

<style scoped>
/* banner 内：图标 + 标题 + 副标题 横向排列 */
.os-banner {
  display: flex;
  align-items: center;
  gap: 18px;
}
.os-banner-icon {
  width: 76px;
  height: 76px;
  border-radius: 18px;
  object-fit: cover;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.4);
  flex-shrink: 0;
}
.os-banner-text {
  min-width: 0;
}
.os-banner-text h1 {
  font-size: 26px;
  font-weight: 800;
  color: #fff;
  margin: 0;
  line-height: 1.3;
}
.os-banner-sub {
  margin: 8px 0 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.92);
  line-height: 1.6;
}

.os-section {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 16px;
  box-shadow: var(--shadow);
  padding: 24px 26px;
  margin-bottom: 18px;
}

/* 富文本详情：图片自适应、段落间距统一 */
.rich-content {
  color: var(--text-sub);
  font-size: 15px;
  line-height: 1.9;
}
.rich-content p {
  margin: 0 0 16px;
}
.rich-content img {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
  margin: 8px 0;
}
.rich-content h1,
.rich-content h2,
.rich-content h3 {
  color: var(--text-main);
  margin: 18px 0 12px;
}

.os-link {
  text-align: center;
  margin-top: 4px;
  margin-bottom: 18px;
}
.os-link-btn {
  display: inline-block;
  background: var(--primary);
  color: #fff;
  padding: 12px 30px;
  border-radius: 24px;
  font-size: 15px;
  font-weight: 700;
  text-decoration: none;
  transition: background 0.2s ease;
}
.os-link-btn:hover {
  background: var(--primary-dark);
}

.os-contact {
  text-align: center;
  margin-top: 26px;
}
.os-contact-btn {
  background: var(--primary);
  color: #fff;
  border: none;
  padding: 13px 38px;
  border-radius: 24px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.2s ease;
}
.os-contact-btn:hover {
  opacity: 0.9;
}
.empty-block {
  text-align: center;
  color: var(--text-sub);
  padding: 40px 0;
}
</style>
